import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=11ba56f6&"
import script from "./editForm.vue.ts?vue&type=script&lang=js&"
export * from "./editForm.vue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports